import React from "react"
import { associateQuestionTemplateIds, clearCategories, loadAssociatedQuestionTemplateIds, loadCategoriesQuestionsTree, loadCategoryNodes, loadSurveyTemplateCategories } from "../../../actions/categories";
import { showDialog } from "../../../actions/dialog";
import { clearActiveMenuItem, setActiveMenuItem, setupMenu, updateMenuRoot } from "../../../actions/menu";
import { getLoggedUser } from "../../../api/session";
import { getSurveyTemplateMenu } from "../../../model/menu";
import { CategoriesStore } from "../../../stores/categories";
import M from "../../../strings";
import { CategoriesTreeSelector } from "../../components/categoriesTreeSelectorControl";
import { QuestionsTreeSelector } from "../../components/questionsTreeSelectorControl";
import { secureScreen } from "../../components/secure";
import { Wizard } from "../../components/wizard";
import EntityForm from "./entityForm"

class _SurveyTemplateHeaderForm extends EntityForm {
    componentDidMount() {
        super.componentDidMount();
    
        const id = this.props.entityId;

        if (id) {
            updateMenuRoot({
                root: getSurveyTemplateMenu(id)
            });

            setActiveMenuItem({id: "surveyTemplate.header"});
        }

        CategoriesStore.subscribe(this, state => {
            this.setState({
                categoryIds: state.selectedCategoryIds,
                questionsTree: state.questionsTree,
                categoryNodes: state.categoryNodes,
                selectedQuestionTemplateIds: state.selectedQuestionTemplateIds
            }) 
        });

        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            loadCategoryNodes();
            loadSurveyTemplateCategories({surveyTemplateId});            
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        CategoriesStore.unsubscribe(this);

        clearCategories();

        clearActiveMenuItem();
        setupMenu({user: getLoggedUser()});
    }

    onLoadQuestionNodes() {
        loadCategoriesQuestionsTree({categoryIds: this.state.categoryIds})
        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            loadAssociatedQuestionTemplateIds({surveyTemplateId, categoryIds: this.state.categoryIds})
        }
    }

    onAssociate() {
        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            associateQuestionTemplateIds({surveyTemplateId, questionTemplateIds: this.state.selectedQuestionTemplateIds})
        }
    }

    onSelectQuestions() {
        showDialog({
            large: true,
            mobile: true,
            title: M("questionsAssociation"),
            getContent: () => (
                <Wizard onFinish={this.onAssociate.bind(this)} finishText={M("save")}>
                    <Wizard.Step id="red" subtitle={M("selectCategories")}>
                        <CategoriesTreeSelector manualLoad={true} startsCollapsed={true} />
                    </Wizard.Step>
                    <Wizard.Step id="yellow" subtitle={M("selectQuestions")} onEnter={this.onLoadQuestionNodes.bind(this)}>
                        <QuestionsTreeSelector manualLoad={true} startsCollapsed={true} />
                    </Wizard.Step>
                </Wizard>
            )
        })
    }
}

export const SurveyTemplateHeaderForm = secureScreen(_SurveyTemplateHeaderForm);